import React, { useState, useEffect } from "react";
import "../styles/ProjectModal.css";

const ProjectModal = ({ project, onClose, onTechClick }) => {
    const [isMediaLoaded, setIsMediaLoaded] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    const [fullScreenMedia, setFullScreenMedia] = useState(null);

    useEffect(() => {
        setIsMediaLoaded(false);
    }, [project]);

    if (!project) return null;

    const getLongDescription = () => {
        return selectedLanguage === 'fr' ? project.longDescriptionFr : project.longDescriptionEn;
    };

    const handleMediaClick = () => {
        if (project.video) {
            setFullScreenMedia({ type: 'video', src: project.videoHd || project.video });
        } else {
            setFullScreenMedia({ type: 'image', src: project.image });
        }
    };

    const handleFullScreenClose = () => {
        setFullScreenMedia(null);
    };

    return (
        <>
            <div className="modal-overlay position-fixed top-0 left-0 d-flex justify-content-center align-items-center" onClick={onClose}>
                <div className="modal-content mt-0 mt-md-5 p-5 text-white text-start overflow-y-auto overflow-x-hidden position-relative" onClick={e => e.stopPropagation()}>
                    <button className="close-button d-flex justify-content-center align-items-center text-white" onClick={onClose}>
                        <i className="bi bi-arrow-right-short"></i>
                    </button>
                    <h1 className="mt-1 mb-3">{project.name}</h1>
                    <p>{project.shortDescription}</p>
                    <div className="position-relative w-100 mt-2 mb-4">
                        {!isMediaLoaded && (
                            <div className="skeleton-image position-absolute top-0 start-0 w-100 h-100" />
                        )}
                        {project.video ? (
                            <video className={`interactive ${isMediaLoaded ? 'opacity-100' : 'opacity-0'}`}
                                poster={project.image}
                                muted
                                loop
                                playsInline
                                autoPlay
                                preload="auto"
                                onLoadedData={() => setIsMediaLoaded(true)}
                                onError={() => setIsMediaLoaded(true)}
                                onClick={handleMediaClick}
                                style={{ cursor: 'pointer', width: '100%' }}>
                                <source src={`${project.video}.webm`} type="video/webm" />
                                <source src={`${project.video}.mp4`} type="video/mp4" />
                            </video>
                        ) : (
                            <img className={`interactive ${isMediaLoaded ? 'opacity-100' : 'opacity-0'}`}
                                src={project.image}
                                alt={project.name}
                                onLoad={() => setIsMediaLoaded(true)}
                                onError={() => setIsMediaLoaded(true)}
                                onClick={handleMediaClick}
                                style={{ cursor: 'pointer', width: '100%' }} />
                        )}
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-1 mb-3">
                        <h3>About</h3>
                        <div className="language-dropdown interactive position-relative">
                            <select
                                value={selectedLanguage}
                                onChange={(e) => setSelectedLanguage(e.target.value)}
                                className="language-select"
                            >
                                <option value="en">EN</option>
                                <option value="fr">FR</option>
                            </select>
                        </div>
                    </div>
                    <p className="mb-2">{getLongDescription()}</p>
                    <hr />
                    <h3 className="mb-3">Technologies</h3>
                    <div className="tech-list">
                        {project.technologies.map((tech, index) => (
                            <span key={index} className="interactive" onClick={() => {
                                if (onTechClick) {
                                    onTechClick(tech);
                                }
                                onClose();
                            }} style={{ cursor: "pointer" }}>{tech}</span>
                        ))}
                    </div>
                    {project.links && (
                        <>
                            <hr />
                            <div className="links mt-2">
                                {project.links.map((link, index) => (
                                    <div key={index} className="mb-4">
                                        <h5 className={link.icon}> {link.name}</h5>
                                        <a href={link.url} target="_blank" rel="noopener noreferrer">
                                            {link.url}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>
            {fullScreenMedia && (
                <div className="fullscreen-overlay position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center p-4"
                    onClick={handleFullScreenClose}>
                    <div className="fullscreen-content position-relative"
                        onClick={e => e.stopPropagation()}>
                        {fullScreenMedia.type === 'video' ? (
                            <video
                                className="fullscreen-video rounded"
                                poster={project.image}
                                muted
                                loop
                                playsInline
                                autoPlay
                                controls
                                controlsList="nodownload noremoteplayback"
                                disablePictureInPicture
                            >
                                <source src={`${fullScreenMedia.src}.webm`} type="video/webm" />
                                <source src={`${fullScreenMedia.src}.mp4`} type="video/mp4" />
                            </video>
                        ) : (
                            <img
                                src={fullScreenMedia.src}
                                alt="Taille réelle"
                                className="fullscreen-image img-fluid rounded"
                            />
                        )}
                        <button className="fullscreen-close-button d-flex justify-content-center align-items-center text-white" onClick={handleFullScreenClose}>
                            <i className="bi bi-x"></i>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ProjectModal;
